import {
  createContext,
  type Dispatch,
  type PropsWithChildren,
  type SetStateAction,
  useState,
} from 'react';

import { type ViewFilters, ViewFiltersMode } from '../entities/view-filters';

export const ViewFiltersContext = createContext<
  [ViewFilters, Dispatch<SetStateAction<ViewFilters>>]
>(
  // @ts-expect-error - This is a placeholder value that should never be used
  undefined,
);

export const ACCURE_SOC_RANGE = { min: 0, max: 1 };
export const BMS_SOC_RANGE = { min: 0, max: 1 };
export const IMBALANCE_SOC_RANGE = { min: 0, max: 0.5 };
export const TEMPERATURE_RANGE = { min: -10, max: 60 };

export function defaultViewFilters(): ViewFilters {
  return {
    viewMode: ViewFiltersMode.REALISTIC,
    accureSoc: ACCURE_SOC_RANGE,
    bmsSoc: BMS_SOC_RANGE,
    imbalanceSoc: IMBALANCE_SOC_RANGE,
    temperature: TEMPERATURE_RANGE,
  };
}

export type ViewFiltersProviderProps = PropsWithChildren<{}>;

export function ViewFiltersProvider({ children }: ViewFiltersProviderProps) {
  const state = useState<ViewFilters>(defaultViewFilters);

  return (
    <ViewFiltersContext.Provider value={state}>
      {children}
    </ViewFiltersContext.Provider>
  );
}
